import React from 'react'
import { LucideIcon } from 'lucide-react'

interface StatsCardProps {
  title: string
  value: string | number
  icon: LucideIcon
  subtitle?: string
  loading?: boolean
  trend?: {
    value: string
    isPositive: boolean
  }
  color?: 'blue' | 'green' | 'yellow' | 'purple'
}

export function StatsCard({
  title,
  value,
  icon: Icon,
  subtitle,
  loading = false,
  trend,
  color = 'blue',
}: StatsCardProps) {
  const colorClasses = {
    blue: 'bg-blue-50 text-blue-600',
    green: 'bg-green-50 text-green-600',
    yellow: 'bg-yellow-50 text-yellow-600',
    purple: 'bg-purple-50 text-purple-600',
  }

  return (
    <div className="bg-white p-3 sm:p-6 rounded-lg shadow-sm border border-gray-200 min-w-0">
      <div className="flex items-center justify-between gap-2">
        <div className="flex-1 min-w-0">
          <p className="text-xs sm:text-sm font-medium text-gray-600 truncate">{title}</p>
          {loading ? (
            <div
              className="mt-1 sm:mt-2 h-7 sm:h-8 w-16 bg-gray-200 rounded animate-pulse"
              aria-hidden="true"
            />
          ) : (
            <p className="mt-1 sm:mt-2 text-lg sm:text-2xl font-bold text-gray-900 truncate">{value}</p>
          )}
          {subtitle && (
            <p className="mt-0.5 text-[11px] sm:text-xs text-gray-400 truncate">{subtitle}</p>
          )}
          {trend && (
            <p
              className={`mt-1 sm:mt-2 text-xs sm:text-sm ${
                trend.isPositive ? 'text-green-600' : 'text-red-600'
              }`}
            >
              {trend.isPositive ? '↑' : '↓'} {trend.value}
            </p>
          )}
        </div>
        <div className={`hidden sm:block p-3 rounded-lg flex-shrink-0 ${colorClasses[color]}`}>
          <Icon className="w-6 h-6" />
        </div>
      </div>
    </div>
  )
}